import { useState } from "react"
import { Box, Typography, useMediaQuery } from "@mui/material"
import { BsCalculator } from "react-icons/bs";
import { FaChevronDown } from "react-icons/fa6";
import CloseIcon from '@mui/icons-material/Close';
import RiskScoreCalculatorMobileNav from "../RiskScoreCalculatorMobileNav";
import RiskScoreCalculatorForm from "../RiskScoreCalculatorForm";

const RiskScoreCalculator = () => {
  const md = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const [isOpened, setIsOpened] = useState(false)

  return (
    <Box>
      <Box
        sx={{
          height: '64px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderRadius: isOpened ? '16px 16px 0 0' : '16px',
          borderBottom: '1px solid',
          borderColor: 'primary.lightGray',
          bgcolor: 'background.default',
          padding: '8px 20px',
          boxShadow: '0px 2px 20px 0px #5B87EF66',
          cursor: 'pointer'
        }}
        onClick={() => setIsOpened(!isOpened)}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <BsCalculator
            color="#5B87EF"
            size={20}
          />
          <Typography variant="h4" ml='4px' mt='2px'>
            ASCVD Calculator
          </Typography>
        </Box>
        <Box>
          {isOpened ? (
            <CloseIcon 
              sx={{
                fontSize: '28px',
                color: 'primary.mediumGray',
                cursor: 'pointer'
              }}
            />
          ) : (
            <FaChevronDown 
              color="#46545F"
              size={22}
              cursor="pointer"
            />
          )}
        </Box>
      </Box>
      {md ? (
        <RiskScoreCalculatorMobileNav
          isOpened={isOpened}
          setIsOpened={() => setIsOpened(!isOpened)}
        />
      ) : (
        <RiskScoreCalculatorForm isOpened={isOpened} />
      )}
    </Box>
  )
}

export default RiskScoreCalculator